<template>
	<div class="mall-home">
		<!-- 搜索区域+热门搜索 -->
		<div class="search-section">
			<div class="search-box">
				<div class="search-input-wrap">
					<input
						v-model="searchKeyword"
						class="search-input"
						type="text"
						placeholder="请输入服务名称搜索"
						@keyup.enter="handleSearch"
					/>
					<i v-if="searchKeyword" class="el-icon-circle-close clear-icon" @click="clearSearch"></i>
				</div>
				<el-button type="primary" class="search-btn" @click="handleSearch">搜索</el-button>
			</div>

			<div class="hot-search">
				<img class="hot-search-img" src="@/assets/mall/hot-search.png" alt="热门搜索" />
				<div class="hot-search-list">
					<span v-for="(item, index) in hotSearchList" :key="index" class="hot-search-item" @click="handleHotSearch(item)">
						{{ item }}
					</span>
				</div>
			</div>
		</div>

		<div class="goods-container">
			<div class="goods-card-list">
				<mall-goods-card
					v-for="(item, index) in goodsList"
					:key="index"
					:goods-id="item.goodsId"
					:image="item.image"
					:title="item.title"
					:price="item.price"
					:sold-count="item.soldCount"
					:contact-phone="item.contactPhone"
					:click-count="item.clickCount"
					:location-fn="() => handleCardClick(item)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import MallGoodsCard from '@/components/MallGoodsCard'

	// 更多商城
	export default {
		name: 'MoreMall',
		components: {
			MallGoodsCard
		},
		props: {},
		data() {
			return {
				searchKeyword: '',
				hotSearchList: ['电子签章', '企业宣传投放', '企业风采投放', '企业风采与宣传定制服务'],
				// 示例数据，后期可替换为接口数据
				goodsList: [
					// {
					// 	goodsId: '1',
					// 	image: require('@/assets/mall/goods/goods-signature.png'),
					// 	title: '电子签章',
					// 	price: '400元/年',
					// 	soldCount: 428,
					// 	clickCount: 6243345,
					// 	path: '/mallStore/goods-signature/'
					// },
					{
						goodsId: '2',
						image: require('@/assets/mall/goods/goods-propaganda.png'),
						title: '企业宣传投放',
						price: '1.5w-5w',
						soldCount: 2659,
						clickCount: 6243345,
						path: '/mallStore/goods-propaganda/'
					},
					{
						goodsId: '3',
						image: require('@/assets/mall/goods/goods-corporate.png'),
						title: '企业风采投放',
						price: '1.5w-5w',
						soldCount: 1375,
						clickCount: 6243345,
						path: '/mallStore/goods-corporate/'
					},
					{
						goodsId: '4',
						image: require('@/assets/mall/goods/goods-customized.png'),
						title: '企业风采与宣传定制服务',
						price: '面议',
						contactPhone: '1859234781',
						clickCount: 6243345,
						path: '/mallStore/goods-customized/'
					}
				]
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 搜索
			handleSearch() {
				console.log('搜索关键词：', this.searchKeyword)
				// TODO: 调用搜索接口或跳转搜索结果页
			},
			// 清除搜索关键词
			clearSearch() {
				this.searchKeyword = ''
			},
			handleCardClick(item) {
				this.$router.push({
					path: item.path + item.goodsId
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mall-home {
		background-color: #eff6f9;
		padding-bottom: 40px;

		.search-section {
			width: $main-page-width;
			margin: 0 auto;
			padding: 40px 0;
		}

		.search-box {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 20px;
			margin-bottom: 20px;

			.search-input-wrap {
				position: relative;
				display: flex;
				align-items: center;

				.search-input {
					width: 850px;
					height: 60px;
					padding: 0 40px 0 20px;
					border: 1px solid #ccc;
					border-radius: 4px;
					font-size: 18px;
					color: #333;
					background-color: #fff;
					outline: none;
					transition: border-color 0.3s;

					&::placeholder {
						color: #999;
					}

					&:focus {
						border-color: #236fca;
						box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
					}
				}

				.clear-icon {
					position: absolute;
					right: 12px;
					font-size: 18px;
					color: #c0c4cc;
					cursor: pointer;
					transition: color 0.3s;

					&:hover {
						color: #909399;
					}
				}
			}

			.search-btn {
				width: 120px;
				height: 60px;
				font-size: 18px;
				border-radius: 4px;
				text-align: center;
			}
		}

		.hot-search {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 34px;

			.hot-search-img {
				width: auto;
				height: 34px;
				margin-right: 16px;
				flex-shrink: 0;
			}

			.hot-search-list {
				display: flex;
				align-items: center;
				flex-wrap: wrap;

				.hot-search-item {
					font-size: 16px;
					color: #666;
					cursor: pointer;
					transition: color 0.3s;
					padding: 0 22px;
					position: relative;

					&:hover {
						color: #236fca;
					}

					// 竖线分隔
					& + .hot-search-item::before {
						content: '|';
						position: absolute;
						left: 0;
						color: #ccc;
					}
				}
			}
		}

		.goods-container {
			width: $main-page-width;
			margin: 0 auto;
			background: #ffffff;
			box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
			border-radius: 6px;
			padding: 20px;

			// 卡片列表：4列网格布局
			.goods-card-list {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: 20px;
				padding: 20px;
				background: #fff;
				border-radius: 8px;
				box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);

				::v-deep(.mall-goods-card) {
					.card-image-wrap {
						aspect-ratio: 1 / 1;
					}
				}
			}
		}
	}
</style>
